import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const StatusCompleteIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 12 12" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M6 10.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm2.142-5.45a.41.41 0 0 0-.601-.555L5.374 6.842l-.926-.927a.41.41 0 1 0-.579.579L5.097 7.72a.41.41 0 0 0 .59-.011l2.455-2.66Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default StatusCompleteIcon;
